var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25600",
    "data-name": "Group 25600",
    transform: "translate(-336 -1188)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 36,
    height: 36,
    transform: "translate(336 1188)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25597",
    "data-name": "Group 25597",
    transform: "translate(-8 157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M24,0H3A3.009,3.009,0,0,0,0,3V24a3.009,3.009,0,0,0,3,3H24a3.009,3.009,0,0,0,3-3V3A3.009,3.009,0,0,0,24,0Z",
    transform: "translate(348.5 1035.267)",
    fill: "#5795c3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "link-24px_3_",
    "data-name": "link-24px (3)",
    transform: "translate(351.181 1037.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13539",
    "data-name": "Path 13539",
    d: "M0,0H21.639V21.639H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13540",
    "data-name": "Path 13540",
    d: "M14.35,7H11.88a.823.823,0,0,0,0,1.647h2.47a2.47,2.47,0,1,1,0,4.94H11.88a.823.823,0,1,0,0,1.647h2.47A4.117,4.117,0,1,0,14.35,7ZM6.94,11.117a.826.826,0,0,0,.823.823H12.7a.823.823,0,1,0,0-1.647H7.763A.826.826,0,0,0,6.94,11.117Zm1.647,2.47H6.117a2.47,2.47,0,1,1,0-4.94h2.47A.823.823,0,0,0,8.586,7H6.117a4.117,4.117,0,0,0,0,8.233h2.47a.823.823,0,0,0,0-1.647Z",
    transform: "translate(0.586 0.208)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/LINK.c791ef69da0d4814554964810e6d1e6b.svg";
export { ForwardRef as ReactComponent };